import { useState, useMemo, useEffect } from 'react';
import { useRunningTradeStore } from 'global/Datafeed/store/runningTrade';
import watchlist from 'lib/api/watchlist';
import AllStock from './AllStock';
import MyWatchlist from './MyWatchlist';
import SearchStock from './SearchStock';
import { ButtonApply, DropdownContentWrapper, FooterWrapper } from './styled';
import { useFilterStore } from '../../store';
import { RunningTradeStockFilter, StockFilterTypeEnum } from '../../types';

interface IDropdownContent {
  isMarketOpen: boolean;
  onClosePopover: () => void;
}

const DropdownContent = ({
  isMarketOpen,
  onClosePopover,
}: IDropdownContent) => {
  const [showResult, setShowResult] = useState(false);

  const defaultFilter = useFilterStore((s) => s.stocksFilter);
  const onApplyFilter = useFilterStore((s) => s.onApplyStockFilter);
  const onResetActionFilter = useFilterStore((s) => s.onResetFilter);

  const [filter, setFilter] = useState<RunningTradeStockFilter>(defaultFilter);

  const clearData = useRunningTradeStore((state) => state.clearData);

  const onClickApply = async () => {
    const appliedFilter = filter;
    if (filter?.type === StockFilterTypeEnum.Watchlist) {
      const res =
        await watchlist.getSymbolWatchlist(filter?.watchlistId);

      if (!res.data) {
        throw new Error('Error while search company data');
      }

      const { data, message, error_type, error } = res.data;

      if (error || error_type) {
        throw new Error(message);
      }

      appliedFilter.selected = data?.symbols;
      setFilter(appliedFilter);
    }

    if (!isMarketOpen && filter?.type === StockFilterTypeEnum.AllStock) {
      onResetActionFilter();
    }

    onApplyFilter(appliedFilter);
    clearData('widget');
    onClosePopover();
  };

  const isButtonDisabled = useMemo(() => {
    if (filter?.type === StockFilterTypeEnum.Custom) {
      if (isMarketOpen) {
        return filter.selected.length === 0;
      }
      return true;
    }
    if (filter?.type === StockFilterTypeEnum.Watchlist) {
      return filter.watchlistItemCounts === 0;
    }
    return filter === null;
  }, [filter]);

  useEffect(() => {
    // reset default active filter
    setFilter(defaultFilter);
  }, []);

  const onApplyStockFilter = (value: RunningTradeStockFilter) => {
    setFilter(value);
    onApplyFilter(value);
    clearData('widget');
    onClosePopover();
  };

  return (
    <div style={{ position: 'relative' }}>
      <DropdownContentWrapper>
        <SearchStock
          filter={filter}
          setFilter={setFilter}
          showResult={showResult}
          onShowSearchResult={(show) => setShowResult(show)}
          onApplyStockFilter={onApplyStockFilter}
          isAllowMultipleSelect={isMarketOpen}
        />
        {!showResult && (
          <>
            <AllStock
              isChecked={filter?.type === StockFilterTypeEnum.AllStock}
              setFilter={setFilter}
            />
            {isMarketOpen && (
              <MyWatchlist
                filter={filter}
                setFilter={setFilter}
              />
            )}
          </>
        )}
      </DropdownContentWrapper>
      {!showResult && (
        <FooterWrapper>
          <ButtonApply
            disabled={isButtonDisabled}
            onClick={onClickApply}
          >
            Apply
          </ButtonApply>
        </FooterWrapper>
      )}
    </div>
  );
};

export default DropdownContent;
